export default "__VITE_ASSET__DzVsS4QO__"